export default __webpack_public_path__ + "static/portfolio_gallery_15-a7a31cdd3202f58862799d1481755aac.jpg";